import CompletedPopup from 'components/FormAddReceiver/components/CompletedPopup';
import { getFullNameReceiver } from 'components/FormEditReceiver/func';
import {
  EDIT_RECEIVER_FISTNAME_NAME,
  EDIT_RECEIVER_LASTNAME_NAME,
  EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME,
  RECEIVERS_PREFIX,
  TRANSACTION_ADD_PREFIX,
} from 'constants';
import Cookies from 'helpers/cookies';
import useFormAddReceiverStore from 'hooks/form-add-receiver/useFormAddReceiverStore';
import { MAKE_PAYMENT_KEY } from 'hooks/form-add-transaction/useAddTransaction';
import useLang from 'hooks/useLang';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { stringUtils } from 'utils';

const withTriggerShowUpdateCompletedModal = (Component) => {
  const TriggerShowUpdateCompletedModalComponent = (props) => {
    const { t } = useLang();
    const { cleanUpFn } = props || {};

    const navigate = useNavigate();

    const {
      editReceiverInformation,
      editReceiverCurrentStep: currentStep,
      currentReceiver,
    } = useFormAddReceiverStore();
    const { personalDetails } = editReceiverInformation || {};

    const currentReceiverType =
      personalDetails[EDIT_RECEIVER_SELECT_TYPE_OF_RECEIVER_NAME];
    const isReceiverOfIndividualType = currentReceiverType === 1;
    const isReceiverOfBusinessType = currentReceiverType === 2;
    const currentReceiverFirstName =
      personalDetails[EDIT_RECEIVER_FISTNAME_NAME];
    const currentReceiverLastName =
      personalDetails[EDIT_RECEIVER_LASTNAME_NAME];

    const handleBackToReceiverList = () => {
      cleanUpFn();
      navigate(`${RECEIVERS_PREFIX}`);
    };

    const handleOnSendNow = () => {
      Cookies.remove(MAKE_PAYMENT_KEY);
      cleanUpFn();
      navigate(`${TRANSACTION_ADD_PREFIX}?rid=${currentReceiver?.receiverId}`);
    };
    const isUpdateCompletedOpen = currentStep === 3 && Boolean(currentReceiver);

    const newProps = {
      ...props,
    };
    return (
      <>
        {isUpdateCompletedOpen ? (
          <CompletedPopup
            isOpen={isUpdateCompletedOpen}
            onClose={handleBackToReceiverList}
            onClick={handleOnSendNow}
            fullName={getFullNameReceiver({
              isReceiverOfBusinessType,
              isReceiverOfIndividualType,
              lastName: currentReceiverFirstName,
              firstName: currentReceiverLastName,
              countryCode: currentReceiver?.address?.country?.code,
            })}
            content={stringUtils.replaceKeyword(
              t('popup_update_old_receiver_success_desktop'),
              [
                {
                  key: 'fullName',
                  value: `<span>${getFullNameReceiver({
                    isReceiverOfBusinessType,
                    isReceiverOfIndividualType,
                    lastName: currentReceiverLastName,
                    firstName: currentReceiverFirstName,
                    countryCode: currentReceiver?.address?.country?.code,
                  })}</span>`,
                },
              ],
            )}
          />
        ) : null}
        <Component {...newProps} />
      </>
    );
  };
  return TriggerShowUpdateCompletedModalComponent;
};

export default withTriggerShowUpdateCompletedModal;
